import React from 'react';
import Menu from './menu';
import imagemLogo from '../../assets/images/sologo.png';

export default props => (
	<aside className="main-sidebar elevation-4 sidebar-light-indigo">
		<a href="../../" className="brand-link navbar-light">
			<img src={imagemLogo} alt="Despachante Logo" className="brand-image"/>
			<span className="brand-text font-weight-light">Despachante</span>
		</a>
		<div className="sidebar">
			<Menu />
		</div>
	</aside>
)
